<template>
  <div class="ms">
    <div class="ms-banner">
      <div class="ms-form-tab">
        <span
          v-for="(item, index) in formTab"
          :key="item.type"
          :class="[typeTab === index ? 'choose-it' : '']"
          @click="changeTab(item.type)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div class="ms-form">
      <div class="ms-form-list">
        <van-form @submit="nextSubmit">
          <div v-if="typeTab === 0" class="accurate">
            <div class="ms-form-input">
              <van-field
                v-model="form.name"
                name="姓名"
                placeholder="请输入您的姓名"
              />
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                v-model="form.idCard"
                name="身份证号"
                placeholder="请输入您的身份证号"
              />
            </div>
            <div class="van-hairline--top ms-border"></div>
          </div>
          <div v-if="typeTab === 1">
            <div class="ms-form-input">
              <van-field
                v-model="form.age"
                name="年龄"
                placeholder="请输入您的年龄"
                label="年龄"
                label-width="110"
              />
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field name="上海户籍" label="上海户籍" label-width="110">
                <template #input>
                  <van-radio-group v-model="form.isSh" direction="horizontal">
                    <van-radio name="yes">是</van-radio>
                    <van-radio name="no">否</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="bizLiveStatusValue"
                label-width="110"
                label="居住情况"
                placeholder="请选择居住情况"
                @click="showBizLiveStatusPicker = true"
              />
              <van-popup v-model="showBizLiveStatusPicker" position="bottom">
                <div class="ms-close" @click="showBizLiveStatusPicker = false">
                  确定
                </div>
                <van-checkbox-group
                  v-model="form.bizLiveStatus"
                  ref="checkboxGroup"
                >
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in bizLiveStatus"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleBizLiveStatus(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="hCtegoryValue"
                label-width="110"
                label="救助类别"
                placeholder="请选择救助类别"
                @click="showHCtegorPicker = true"
              />
              <van-popup v-model="showHCtegorPicker" position="bottom">
                <div class="ms-close" @click="showHCtegorPicker = false">
                  确定
                </div>
                <van-checkbox-group v-model="form.hCtegory" ref="checkboxGroup">
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in hCtegory"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleHCtegor(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="familyTypeValue"
                label-width="110"
                label="家庭类别"
                placeholder="请选择家庭类别"
                @click="showFamilyTypePicker = true"
              />
              <van-popup v-model="showFamilyTypePicker" position="bottom">
                <div class="ms-close" @click="showFamilyTypePicker = false">
                  确定
                </div>
                <van-checkbox-group
                  v-model="form.familyType"
                  ref="checkboxGroup"
                >
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in familyType"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleFamilyType(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="defoTypeValue"
                label-width="110"
                label="残疾类别"
                placeholder="请选择残疾类别与等级"
                @click="showDefoTypeLevelPicker = true"
              >
              </van-field>
              <van-popup v-model="showDefoTypeLevelPicker" position="bottom"  :style="{ height: '100px' }" :close-on-click-overlay="false">
                <div class="ms-close" @click="defoSelect">
                  确定
                </div>
                <el-cascader
                  v-model="defoType"
                  style="width:100%; position:absolute;"
                  :props="props"
                  :options="deformityTypeOptions"
                  placeholder="请点击选择残疾类别与等级"
                  clearable
                  @change="changeDisable"
                />
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="entitledGroupsValue"
                label-width="110"
                label="优抚类别"
                placeholder="请选择优抚类别"
                @click="showEntitledGroupsPicker = true"
              />
              <van-popup v-model="showEntitledGroupsPicker" position="bottom">
                <div class="ms-close" @click="showEntitledGroupsPicker = false">
                  确定
                </div>
                <van-checkbox-group
                  v-model="form.entitledGroups"
                  ref="checkboxGroup"
                >
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in entitledGroups"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleEntitledGroups(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="bizAssessLevelValue"
                label-width="110"
                label="长护险评估"
                placeholder="请选择长护险评估"
                @click="showBizAssessLevelPicker = true"
              />
              <van-popup v-model="showBizAssessLevelPicker" position="bottom">
                <div class="ms-close" @click="showBizAssessLevelPicker = false">
                  确定
                </div>
                <van-checkbox-group
                  v-model="form.bizAssessLevel"
                  ref="checkboxGroup"
                >
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in bizAssessLevel"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleBizAssessLevel(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
            <div class="ms-form-input">
              <van-field
                readonly
                clickable
                name="picker"
                :value="isEnjoyValue"
                label-width="110"
                label="居家养老评估"
                placeholder="请选择居家养老评估"
                @click="showIsEnjoyPicker = true"
              />
              <van-popup v-model="showIsEnjoyPicker" position="bottom">
                <div class="ms-close" @click="showIsEnjoyPicker = false">
                  确定
                </div>
                <van-checkbox-group v-model="form.isEnjoy" ref="checkboxGroup">
                  <van-cell-group ref="checkboxGroup">
                    <van-cell
                      v-for="(item, index) in isEnjoy"
                      clickable
                      :key="item.dictValue"
                      :title="item.dictLabel"
                      @click="toggleIsEnjoyLevel(index)"
                    >
                      <template #right-icon>
                        <van-checkbox :name="item.dictValue" ref="checkboxes" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </van-popup>
            </div>
            <div class="van-hairline--top ms-border"></div>
          </div>
        </van-form>
      </div>
    </div>
    <div v-if="typeTab === 0" class="bottom-font">
      <p>哪些服务可以享受？</p>
      <p>哪些政策适合你？</p>
      <p>动手查一查，来定制你的服务方案吧.</p>
    </div>
    <div class="ms-btn" @click="nextSubmit">
      查 询
    </div>
    <div style="width: 100%;height: 30px"></div>
  </div>
</template>

<script>
import {
  getArea,
  allSelectdictionaryData,
  getLabel
} from "@/api/careConsultant";
import { pageModel } from "@/common/constants.js";
import { verifyIdCard } from "@/utils/validate";
import _ from "lodash";
export default {
  name: "index",
  data() {
    return {
      props: { multiple: true, checkStrictly: true },
      typeTab: 0,
      formTab: [
        {
          name: "精确查询",
          type: 0
        },
        {
          name: "模糊查询",
          type: 1
        }
      ],
      value: "",
      columns: [
        {
          dictLabel: "全部",
          dictValue: "0"
        },
        {
          dictLabel: "老人",
          dictValue: "1"
        },
        {
          dictLabel: "残疾人",
          dictValue: "2"
        },
        {
          dictLabel: "优抚人员",
          dictValue: "3"
        },
        {
          dictLabel: "社会救助人员",
          dictValue: "4"
        },
        {
          dictLabel: "计生人员",
          dictValue: "5"
        }
      ],
      showPicker: false,
      showMonthlyPicker: false,
      addressShowPicker: false,
      showBizLiveStatusPicker: false,
      showHCtegorPicker: false,
      showFamilyTypePicker: false,
      showDefoTypePicker: false,
      showDefoTypeLevelPicker: false,
      showDefoLevelPicker: false,
      showEntitledGroupsPicker: false,
      showBirthControlFamilyPicker: false,
      showBizAssessLevelPicker: false,
      showIsEnjoyPicker: false,
      form: {
        idCard: "",
        name: "",
        objectTypes: [],
        isSh: "yes", // 是否是上海户籍
        monthlyCapita: [], // 家庭人均收入
        bizLiveStatus: [], // 居中情况
        hCtegory: [], // 救助类别
        familyType: [], // 家庭类别
        defoType: [], // 残疾类型
        defoLevel: [], // 残疾等级
        entitledGroups: [], // 优抚类别
        birthControlFamily: [], // 计生家庭
        bizAssessLevel: [], // 长护险
        isEnjoy: [], // 居家养老评估
        dictTags: [], // 字典
        age: "",
        selectType: 1,
        pageNum: pageModel.pageNum, // 分页页数
        pageSize: pageModel.pageSize // 分页数量
      },
      addressList: [
        {
          areaName: "浦锦街道",
          areaCode: "310112009000",
          children: []
        }
      ],
      codes: [],
      objectTypesValue: "",
      objectTypesList: [],
      monthlyCapita: [],
      monthlyCapitaValue: "",
      bizLiveStatus: [],
      bizLiveStatusValue: "",
      hCtegory: [],
      hCtegoryValue: "",
      familyType: [],
      familyTypeValue: "",
      defoType: [],
      defoTypeValue: "",
      defoLevel: [],
      defoLevelValue: "",
      defoValue: "",
      deformityTypeOptions: [], // 残疾
      entitledGroups: [],
      entitledGroupsValue: "",
      birthControlFamily: [],
      birthControlFamilyValue: "",
      bizAssessLevel: [],
      bizAssessLevelValue: "",
      isEnjoy: "",
      isEnjoyValue: ""
    };
  },
  mounted() {
    this.getAreas();
    this.selectData();
  },
  methods: {
    defoSelect() {
      this.showDefoTypeLevelPicker = false;
      this.form.defoType = [];
      let dom = document.querySelectorAll(".el-tag--light span");
      let str = "";
      dom.forEach(item => {
        str += item.innerText + ";";
      });
      this.defoTypeValue = str;
    },
    changeDisable(val) {
      this.deformityTypeOptions.forEach(item => {
        if (val && val.length) {
          // eslint-disable-next-line no-unused-vars
          val.forEach(items => {
            item.children.forEach(itemc => {
              itemc.disabled = false;
            });
          });
        }
      });
      this.deformityTypeOptions.forEach(item => {
        if (val && val.length) {
          val.forEach(items => {
            if (item.value == items[0]) {
              item.children.forEach(itemc => {
                if (items[1] !== itemc.value) {
                  itemc.disabled = true;
                } else {
                  itemc.disabled = false;
                }
              });
            }
          });
        } else {
          this.deformityTypeOptions.forEach(item => {
            item.children.forEach(itemc => {
              this.$set(itemc, "disabled", false);
            });
          });
        }
      });
    },
    changeTab(type) {
      this.typeTab = type;
      if (type === 1) {
        this.getLabels();
      }
    },
    toggleIsEnjoyLevel() {
      setTimeout(() => {
        this.allToggle(this.form.isEnjoy, this.isEnjoy, "isEnjoyValue");
      }, 10);
    },
    toggleBizAssessLevel() {
      setTimeout(() => {
        this.allToggle(
          this.form.bizAssessLevel,
          this.bizAssessLevel,
          "bizAssessLevelValue"
        );
      }, 10);
    },
    toggleBirthControlFamily() {
      setTimeout(() => {
        this.allToggle(
          this.form.birthControlFamily,
          this.birthControlFamily,
          "birthControlFamilyValue"
        );
      }, 10);
    },
    toggleEntitledGroups() {
      setTimeout(() => {
        this.allToggle(
          this.form.entitledGroups,
          this.entitledGroups,
          "entitledGroupsValue"
        );
      }, 10);
    },
    toggleDefoLevel() {
      setTimeout(() => {
        this.allToggle(this.form.defoLevel, this.defoLevel, "defoLevelValue");
      }, 10);
    },
    toggleDefoType() {
      setTimeout(() => {
        this.allToggle(this.form.defoType, this.defoType, "defoTypeValue");
      }, 10);
    },
    toggleFamilyType() {
      setTimeout(() => {
        this.allToggle(
          this.form.familyType,
          this.familyType,
          "familyTypeValue"
        );
      }, 10);
    },
    toggleHCtegor() {
      setTimeout(() => {
        this.allToggle(this.form.hCtegory, this.hCtegory, "hCtegoryValue");
      }, 10);
    },
    toggleBizLiveStatus() {
      setTimeout(() => {
        this.allToggle(
          this.form.bizLiveStatus,
          this.bizLiveStatus,
          "bizLiveStatusValue"
        );
      }, 10);
    },
    toggleMonthlyCapita() {
      setTimeout(() => {
        this.allToggle(
          this.form.monthlyCapita,
          this.monthlyCapita,
          "monthlyCapitaValue"
        );
      }, 10);
    },
    allToggle(arr, allArr, value) {
      this[value] = "";
      arr.forEach(item => {
        allArr.forEach(list => {
          if (item === list.dictValue) {
            if (this[value] === "") {
              this[value] = this[value] + list.dictLabel;
            } else {
              this[value] = this[value] + "," + list.dictLabel;
            }
          }
        });
      });
    },
    asyncValidator() {
      return new Promise(() => {
        verifyIdCard;
      });
    },
    noClick() {
      if (this.form.isSh === "no") {
        this.$notify({ type: "warning", message: "非上海户籍不能选择区域！" });
      } else {
        this.addressShowPicker = true;
      }
    },
    toggle(index) {
      this.objectTypesValue = "";
      let ylength = this.objectTypesList.length;
      this.$refs.checkboxes[index].toggle();
      setTimeout(() => {
        if (index === 0) {
          if (this.objectTypesList[this.objectTypesList.length - 1] == index) {
            this.$refs.checkboxGroup.toggleAll(true);
            setTimeout(() => {
              this.objectTypesValue = "全部";
              this.form.objectTypes = [];
            }, 100);
          } else {
            this.$refs.checkboxGroup.toggleAll(false);
            setTimeout(() => {
              this.objectTypesValue = "";
              this.form.objectTypes = [];
            }, 100);
          }
        }
        if (index !== 0) {
          if (this.objectTypesList.length === 5) {
            if (ylength === 6) {
              this.$refs.checkboxes[0].toggle(false);
              setTimeout(() => {
                this.columns.forEach(item => {
                  this.objectTypesList.forEach(list => {
                    if (item.dictValue === list) {
                      if (this.objectTypesValue === "") {
                        this.objectTypesValue =
                          this.objectTypesValue + item.dictLabel;
                      } else {
                        this.objectTypesValue =
                          this.objectTypesValue + "," + item.dictLabel;
                      }
                    }
                  });
                });
                this.form.objectTypes = this.objectTypesList;
              }, 100);
            } else {
              this.$refs.checkboxes[0].toggle(true);
              setTimeout(() => {
                this.objectTypesValue = "全部";
                this.form.objectTypes = [];
              }, 100);
            }
          } else {
            this.$refs.checkboxes[0].toggle(false);
            setTimeout(() => {
              this.columns.forEach(item => {
                this.objectTypesList.forEach(list => {
                  if (item.dictValue === list) {
                    if (this.objectTypesValue === "") {
                      this.objectTypesValue =
                        this.objectTypesValue + item.dictLabel;
                    } else {
                      this.objectTypesValue =
                        this.objectTypesValue + "," + item.dictLabel;
                    }
                  }
                });
              });
              this.form.objectTypes = this.objectTypesList;
            }, 100);
          }
        }
      }, 100);
    },
    // 循环遍历多选塞入数组中
    pushArr(arr, allArr, name) {
      arr.forEach(item => {
        const data = {};
        data.dictType = name;
        data.dictValue = item;
        allArr.push(data);
      });
    },
    async nextSubmit() {
      if (this.typeTab === 0 && this.form.idCard !== "") {
        await this.getLabels();
      }
      await this.onSubmit();
    },
    onSubmit() {
      return new Promise(resolve => {
        const data = {};
        if (this.typeTab === 0) {
          if (this.form.name === "") {
            this.$notify({ type: "danger", message: "姓名不能为空！" });
            return false;
          } else if (this.form.idCard === "") {
            this.$notify({ type: "danger", message: "身份证号不能为空！" });
            return false;
          } else if (this.form.idCard !== "") {
            const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
            if (!reg.test(this.form.idCard)) {
              this.$notify({
                type: "danger",
                message: "请输入正确的身份证号！"
              });
              return false;
            }
          }
        }
        if (this.typeTab === 1) {
          if (this.form.idCard !== "") {
            const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
            if (!reg.test(this.form.idCard)) {
              this.$notify({
                type: "danger",
                message: "请输入正确的身份证号或把身份证置为空！"
              });
              return false;
            }
          }
        }
        data.idCard = this.form.idCard;
        data.age = this.form.age;
        data.objectTypes = this.form.objectTypes;
        data.dictTags = [];
        if (this.form.isSh === "no") {
          const arr = {};
          arr.dictType = "people_category";
          arr.dictValue = "p_population";
          data.dictTags.push(arr);
        }
        this.pushArr(this.form.monthlyCapita, data.dictTags, "monthly_capita"); // 家庭人均收入
        this.pushArr(this.form.bizLiveStatus, data.dictTags, "biz_live_status"); // 居住情况
        this.pushArr(this.form.hCtegory, data.dictTags, "h_category"); // 救助类别
        this.pushArr(this.form.familyType, data.dictTags, "family_type"); // 家庭类别
        // this.pushArr(this.form.defoType, data.dictTags, "defo_type"); // 残疾类型
        // this.pushArr(this.form.defoLevel, data.dictTags, "defo_level"); // 残疾等级
        this.pushArr(
          this.form.entitledGroups,
          data.dictTags,
          "entitled_groups"
        ); // 优抚类别
        this.pushArr(
          this.form.birthControlFamily,
          data.dictTags,
          "birthControl_family"
        ); // 计生家庭
        this.pushArr(
          this.form.bizAssessLevel,
          data.dictTags,
          "biz_assess_level"
        ); // 长护险
        this.pushArr(this.form.isEnjoy, data.dictTags, "is_enjoy"); // 居家养老评估
        if (this.defoTypeValue) {
          this.defoType.forEach(item => {
            this.pushArr([item[0]], data.dictTags, "defo_type");
            this.pushArr([item[1]], data.dictTags, "defo_level");
          });
        }
        this.$router.push({
          path: "/queryResult",
          query: {
            data: JSON.stringify(data),
            type: this.typeTab
          }
        });
        resolve();
      });
    },

    getAreas() {
      getArea("310112009000").then(res => {
        this.addressList[0].children = res;
        this.codes = res;
      });
    },
    selectData() {
      let dicKey =
        "monthly_capita,biz_live_status,h_category,family_type,defo_type,defo_level,entitled_groups,birthControl_family,biz_assess_level,is_enjoy";
      allSelectdictionaryData(dicKey).then(response => {
        if (response) {
          for (let k in response) {
            switch (k) {
              // 家庭人均收入
              case "monthly_capita":
                this.monthlyCapita = response[k];
                break;
              // 居住情况
              case "biz_live_status":
                this.bizLiveStatus = response[k];
                break;
              // 救助类别
              case "h_category":
                this.hCtegory = response[k];
                break;
              // 家庭类别
              case "family_type":
                this.familyType = response[k];
                break;
              // 残疾类型
              case "defo_type":
                this.defoType = response[k];
                break;
              // 残疾等级
              case "defo_level":
                this.defoLevel = response[k];
                break;
              // 优抚类别
              case "entitled_groups":
                this.entitledGroups = response[k];
                break;
              // 计生家庭
              case "birthControl_family":
                this.birthControlFamily = response[k];
                break;
              // 长护险
              case "biz_assess_level":
                this.bizAssessLevel = response[k];
                break;
              // 居家养老评估
              case "is_enjoy":
                this.isEnjoy = response[k];
                break;
            }
          }
        }
        //处理成树形结构
        const defoTypeOptions = [];
        const defoLevelOptions = [];
        this.defoLevel.forEach(item => {
          defoLevelOptions.push({
            value: item.dictValue,
            label: item.dictLabel,
            disabled: false
          });
        });
        this.defoType.forEach(item => {
          const arrList = _.cloneDeep(defoLevelOptions);
          defoTypeOptions.push({
            value: item.dictValue,
            label: item.dictLabel,
            disabled: true,
            children: arrList
          });
        });
        this.deformityTypeOptions = defoTypeOptions;
      });
    },
    // 字典匹配公共方法
    getLabelWay(name, data) {
      if (data) {
        const datas = [];
        let myName = name + "Value";
        // 处理逗号隔开
        if (data.indexOf(",") !== -1) {
          this.form[name] = Array.from(new Set(data.split(",")));
          const newArr = [];
          this[name].forEach(item => {
            Array.from(new Set(data.split(","))).forEach(list => {
              if (item.dictValue === list) {
                newArr.push(item.dictLabel);
              }
            });
          });
          this[myName] = newArr.join(",");
          return;
        } else {
          datas.push(data);
          this[myName] = data;
          this[name].forEach(item => {
            if (item.dictValue === data) {
              this[myName] = item.dictLabel;
            }
          });
        }
        this.form[name] = datas;
      }
    },
    getLabels() {
      return new Promise((resolve, reject) => {
        if (this.form.idCard !== "") {
          getLabel({
            idCard: this.form.idCard
          }).then(res => {
            if (res.code === 0) {
              // this.getLabelWay("bigAgeLevel", res.data.ageLevel);
              this.getLabelWay("bizLiveStatus", res.data.liveStatus);
              this.getLabelWay("assessLevel", res.data.bizAssessLevel);
              this.getLabelWay("hCtegory", res.data.succorCategory);
              this.getLabelWay("familyType", res.data.familyType);
              this.getLabelWay("defoType", res.data.defoType);
              // this.getLabelWay("category", res.data.category);
              this.getLabelWay("defoLevel", res.data.defoLevel);
              this.getLabelWay("entitledGroups", res.data.preferType);
              this.getLabelWay("birthControlFamily", res.data.familyPlanning);
              // this.getLabelWay(
              //   "birthControlSubsidy",
              //   res.data.familyPlanningAllowance
              // );
              // this.getLabelWay("sex", res.data.sex);
              const myDatas = [];
              myDatas.push(res.data.assessType);
              myDatas.push(res.data.assessLevel + res.data.assessType);
              this.form.bizAssessType = myDatas;
              this.form.age = res.data.age;
              resolve();
            } else {
              this.$message.error(res.msg);
              reject();
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.ms {
  ::v-deep .el-input__inner{max-height: 3.1rem; overflow-y: hidden;}
  width: 100%;
  min-height: 100%;
  .ms-banner {
    width: 100%;
    height: 150px;
    background: url("~@/assets/images/bgi2.png");
    background-size: contain;
    .ms-form-tab {
      width: 100%;
      height: 150px;
      background: url("~@/assets/images/bgi1.png");
      background-size: contain;
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
      padding-bottom: 40px;
      span {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #543302;
        opacity: 0.44;
        line-height: 28px;
      }
      .choose-it {
        opacity: 1;
      }
    }
  }
  .ms-form {
    width: calc(100% - 30px);
    margin: 0 15px 30px 15px;
    background: #ffffff;
    border-radius: 5px;
    padding: 0 0 15px 0;
    p {
      margin-bottom: 10px;
    }
    .ms-form-list {
      width: 100%;
      padding: 10px 10px;
      .accurate {
        .ms-form-input {
          margin-top: 60px;
          input {
            color: #7a7a7a;
            text-align: center;
          }
        }
      }
    }
  }
  .bottom-font {
    color: #7ec3ec;
    opacity: 1;
    p {
      font-size: 16px;
      font-style: oblique;
      text-align: center;
      margin: 10px 0;
    }
  }
  .van-field {
    padding: 0;
  }
  .van-cell:not(:last-child)::after {
    border: 0;
  }
  .ms-form-input {
    width: 100%;
    padding-bottom: 5px;
    position: relative;
    .ms-select {
      position: absolute;
      right: 0;
      top: 6px;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg);
    }
  }
  .ms-border {
    padding-bottom: 15px;
  }
  .ms-border:after {
    border-color: #e0e0e0;
  }
  .ms-close {
    width: 100%;
    text-align: right;
    padding: 10px;
    font-size: 16px;
  }
  .ms-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    color: #543302;
    background-color: #7dceff;
  }
}
.van-popup {
  width: 100% !important;
  overflow: visible;
}
.require-mes:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.el-popper {
  z-index: 3000 !important;
}
.van-field__label {
  color: #543302;
  span {
    padding-right: 15px;
    border-right: 1px solid #707070;
  }
}
</style>
